// App-side delegate for `@heidi/templates/data` (D2.2, ARCFE-1026).
// The analytics dispatch stayed and fires from a port INSIDE the queryFn, at
// the position it always occupied — see the package hook for why that ordering
// matters.
import { trackCommunityTemplateViewed } from '@/lib/analytics/scribe/community';
import { useQueryCommunityTemplateByTemplateUrlPath as useQueryCommunityTemplateByTemplateUrlPathCore } from '@heidi/templates/data';

export function useQueryCommunityTemplateByTemplateUrlPath(urlPath: string) {
  return useQueryCommunityTemplateByTemplateUrlPathCore(urlPath, (templateId) => {
    trackCommunityTemplateViewed({ templateId });
  });
}
